import Layout, { ILayoutProps } from '@/components/Layout';
import Loading from '@/components/Loading';
import useQueries from '@/hooks/useQueries';
import Login from '@/screens/Login';
import useAuth from '@/stores/auth';
import useGlobalConfigs from '@/stores/globalConfigs';
import { Result } from 'antd';
import * as React from 'react';

export interface IPrivateRouterProps extends ILayoutProps {
  roles?: string[];
}

export default function PrivateRouter({ children, roles, ...rest }: IPrivateRouterProps): React.ReactElement {
  const user = useAuth((s) => s.user);
  const [queries] = useQueries();

  const emrTypes = useGlobalConfigs((state) => state.emrTypes);
  const isPassRoles = !roles?.length || roles.find((r) => user?.roles?.includes(r));

  if (queries.token) {
    return <Layout {...rest}>{children}</Layout>;
  }

  if (!user) {
    return <Login />;
  }

  if (!emrTypes) {
    return <Loading loading />;
  }

  if (!isPassRoles) {
    <Result status="403" title="403" subTitle="Sorry, the page you visited does not exist." />;
  }

  return <Layout {...rest}>{children}</Layout>;
}
